enum VendorSubscriptionFrom {
  User = 'User',
  Workspace = 'Workspace',
  Everyone = 'Everyone',
  None = 'None',
}

export default VendorSubscriptionFrom;
